import * as observable from 'lib0/observable'

class RecordingAwareness extends observable.Observable {
  constructor(doc) {
    super()
    this.doc = doc

    this.states = new Map()

    this.meta = new Map()
  }

  destroy() {
    super.destroy()
  }

  getLocalState() {
    return this.states.get(this.doc.clientID) || null
  }

  setLocalState() {}

  setLocalStateField() {}

  getStates() {
    return this.states
  }
}

export default RecordingAwareness
